import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  selectEditRecordDialogData,
  selectSelectedRecord,
  selectSelectedRecordBreakRecordsEditAttributesArray,
} from '../selectors/records.selectors';
import updateRecord from '../services/updateRecord';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const editRecord = createAsyncThunk(
  'recordDialog/editRecord',
  async (_, { getState }) => {
    const selectedRecord = selectSelectedRecord(getState());
    let recordUpdateAttributes = selectEditRecordDialogData(getState());

    const originalRecordProjectId = selectedRecord.project;
    const updateAttributesProjectId = recordUpdateAttributes.project;

    const selectedRecordBreakRecordsEditAttributes =
      selectSelectedRecordBreakRecordsEditAttributesArray(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    if (recordUpdateAttributes.status === 'IN') {
      recordUpdateAttributes = {
        ...recordUpdateAttributes,
        billedClockOutAt: undefined,
        clockOutAt: undefined,
      };
    }

    const records = await updateRecord({
      record: recordUpdateAttributes,
      projectIds: [originalRecordProjectId, updateAttributesProjectId],
      breakRecordsUpdateAttributes: selectedRecordBreakRecordsEditAttributes,
      activeEmployerInfo,
    });
    return records;
  }
);
